module.exports = __webpack_public_path__ + "static/img/home-pub-bh.1448ae06.jpg";